import React from "react";
import { Table, type TableProps } from "antd";

export interface PageTableProps extends TableProps<Record<string, unknown>> {
  /** 水平滚动宽度 */
  scrollX?: number;
  /** 是否显示分页器 */
  showPagination?: boolean;
  /** 默认页面大小 */
  defaultPageSize?: number;
}

type DocgenInfo = {
  displayName: string;
  description: string;
  props: Record<string, {
    name: string;
    required: boolean;
    description: string;
    type: { name: string; raw: string };
    defaultValue?: { value: string };
  }>;
};

type ComponentWithDocgen = React.FC<PageTableProps> & { __docgenInfo?: DocgenInfo };

/** 页面级表格组件，高度铺满容器，自动滚动 */
export const PageTable: React.FC<PageTableProps> = ({
  scrollX,
  showPagination = true,
  defaultPageSize = 10,
  ...props
}) => {
  return (
    <Table
      {...props}
      scroll={{ 
        x: scrollX || 'max-content', 
        y: '50vh' 
      }}
      pagination={showPagination ? {
        hideOnSinglePage: true,
        showSizeChanger: true,
        showQuickJumper: true,
        defaultPageSize,
        ...props.pagination,
      } : false}
    />
  );
};

// 手动添加 docgen 信息
(PageTable as ComponentWithDocgen).__docgenInfo = {
  displayName: "PageTable",
  description: "页面级表格组件，高度铺满容器，自动滚动",
  props: {
    scrollX: {
      name: "scrollX",
      required: false,
      description: "水平滚动宽度",
      type: { name: "number", raw: "number" }
    },
    showPagination: {
      name: "showPagination",
      required: false,
      description: "是否显示分页器",
      type: { name: "boolean", raw: "boolean" },
      defaultValue: { value: "true" }
    },
    defaultPageSize: {
      name: "defaultPageSize",
      required: false,
      description: "默认页面大小",
      type: { name: "number", raw: "number" },
      defaultValue: { value: "10" }
    },
    columns: {
      name: "columns",
      required: false,
      description: "表格列配置",
      type: { name: "ColumnType[]", raw: "ColumnType<any>[]" }
    },
    dataSource: {
      name: "dataSource",
      required: false,
      description: "数据源",
      type: { name: "any[]", raw: "any[]" }
    },
    loading: {
      name: "loading",
      required: false,
      description: "是否加载中",
      type: { name: "boolean", raw: "boolean" }
    },
    rowKey: {
      name: "rowKey",
      required: false,
      description: "行数据的 Key",
      type: { name: "string | function", raw: "string | ((record: any) => string)" }
    }
  }
};
